import { render, staticRenderFns } from "./AddRoleDialog.vue?vue&type=template&id=8495ef92"
import script from "./AddRoleDialog.vue?vue&type=script&lang=js"
export * from "./AddRoleDialog.vue?vue&type=script&lang=js"
import style0 from "./AddRoleDialog.vue?vue&type=style&index=0&id=8495ef92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports